import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyModule, type LazyComponent } from "owa-bundling";
import type { TasksHubProps } from "./components/TasksHub";

import "./orchestrators/onCopilotChatDrawerClosed";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "CopilotChatTasksHub" */ "./lazyIndex"), { name: "CopilotChatTasksHub" });

export const LazyTasksHub: LazyComponent<TasksHubProps, undefined> = createLazyComponent(lazyModule, m => m.TasksHub);

export { setTasksHubActiveMutator } from "./mutators/setTasksHubActiveMutator";
export { logTasksHubClosed } from "./utils/logTasksHubClosed";
export { openCopilotTasksHub } from "./utils/openCopilotTasksHub";
export type { TasksHubViewSource } from "./utils/logTasksHubViewed";
export type { TasksHubExternalSection } from "./components/TasksHubExternalSection";
